import { Modal, Form } from 'antd'
import useFileUploadModal from 'hooks/clients/Modals/useFileUploadModal'
import { FileInputContainer, FileInputLabel, FileName, StyledFileInput } from './FileUploadModal.styles'
import CustomFormItem from 'components/CustomFormItem'
import { yesNoOptions } from 'utils/commonOptions'

const FileUploadModal = () => {
  const {
    modalState,
    handleCancelClick,
    handleConfirmClick,
    description,
    handleCustomTextAreaChange,
    handleAntdFormItemChange,
    isKFI,
    fileName,
    handleFileInput,
    isSaveEnabled,
    form,
  } = useFileUploadModal()

  return (
    <Modal
      title="Upload File"
      open={modalState.isOpen}
      onOk={handleConfirmClick}
      onCancel={handleCancelClick}
      width={700}
      okText="Save"
      cancelText="Cancel"
      closable={false}
      className="edit-asset-modal"
      confirmLoading={modalState.loading}
      okButtonProps={{ disabled: !isSaveEnabled }}
    >
      <FileInputContainer>
        <StyledFileInput id="fileInput" type="file" onChange={handleFileInput} required />
        <FileInputLabel htmlFor="fileInput">Choose a file</FileInputLabel>
        {fileName && <FileName>Selected File: {fileName}</FileName>}
      </FileInputContainer>
      <Form
        layout="vertical"
        size="large"
        name="basic"
        style={{
          display: 'flex',
          flexDirection: 'column',
          rowGap: '12px',
        }}
        form={form}
        initialValues={{
          isKFI: isKFI,
        }}
      >
        <CustomFormItem
          label="Is this KFI file?"
          onChange={handleAntdFormItemChange}
          options={yesNoOptions}
          defaultValue={isKFI}
          value={isKFI}
          name="isKFI"
          type="radio"
        />
        <CustomFormItem
          placeholder="Description"
          value={description}
          name="description"
          onChange={handleCustomTextAreaChange}
          rows={4}
          type="textarea"
          rules={['isRequired']}
        />
      </Form>
    </Modal>
  )
}

export default FileUploadModal
